import React from 'react';

function CheckboxQuestion({ question, value, onChange }) {
  const handleChange = (optionValue, isExclusive) => {
    let newValue;
    if (isExclusive) {
      newValue = value.includes(optionValue) ? [] : [optionValue];
    } else {
      // Remove exclusive option if it was selected
      const exclusiveOption = question.options.find(o => o.exclusive);
      const filteredValue = exclusiveOption ? 
        value.filter(v => v !== exclusiveOption.value) : value;
      
      if (filteredValue.includes(optionValue)) {
        newValue = filteredValue.filter(v => v !== optionValue);
      } else {
        // Check max select
        if (question.maxSelect && filteredValue.length >= question.maxSelect) {
          return; // Don't allow more selections
        }
        newValue = [...filteredValue, optionValue];
      }
    }
    onChange(newValue);
  };

  return (
    <div className="options-container">
      {question.options.map(option => (
        <div
          key={option.value}
          className={`option-item ${value.includes(option.value) ? 'selected' : ''}`}
          onClick={() => handleChange(option.value, option.exclusive)}
        >
          <input
            type="checkbox"
            value={option.value}
            checked={value.includes(option.value)}
            onChange={() => handleChange(option.value, option.exclusive)}
          />
          <span className="option-label">{option.label}</span>
        </div>
      ))}
    </div>
  );
}

export default CheckboxQuestion;
